import styled from 'styled-components';

export const BaseStyled = styled.div`
  display: grid;
  grid-template-columns: 25px auto 30px;
  grid-template-rows: 30px auto;
  grid-column-gap: 5px;
  padding: 5px;
  color: white;
  align-items: center;

  > span {
    grid-column: 1;
    grid-row: 1;
  }

  > input {
    grid-column: 2;
    grid-row: 1;
  }

  > .FAButton {
    grid-column: 3;
    grid-row: 1;
  }

  > div {
    grid-column-start: 2;
    grid-column-end: 4;
    grid-row: 2;
    position: relative;
    width: 100%;
    height: 100%;
  }

`;